import { format } from 'date-fns';

const dateTime = (value, def = '') => {
  if (!value) {
    return def || '';
  }
  const myDate = typeof value === 'string' ? new Date(value) : value;
  return `${format(myDate, 'MM/dd/yyyy h:mm a')}`;
};

export default dateTime;
